import { COMPONENTS, EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { BonusGameFinishedView } from '../../view/bonus-game/BonusGameFinished';
import MainGridController from '../../controllers/grid/MainGridController';
import { MainViewGrid } from '../../view/MainViewGrid';
import { FreespinStatusbarView } from '../../view/freespin/FreespinStatusbarView';
import { FreespinWinView } from '../../view/freespin/FreespinWinView';
import SamuraiLayer from '../background/SamuraiLayer';
import bonusbgimg from '../../lib/logo/bonus_background.jpg';

export function initSamuraiSplashScreen(that) {
	that.samurai = new SamuraiLayer();
	that.samurai_anim = HELPERS.getAnimatedSprite({
		pattern: 'spidertransition$.png',
		start: 0,
		end: 13,
		speed: 0.5,
		precision: 2,
		loop: false
	});
	that.samurai.zIndex = 1;
	that.samurai.visible = false;
	that.samurai_anim.visible = false;
	that.samurai_anim.anchor.set(0.5, 0.5);
	that.samurai_anim.zIndex = 2;
	that.samurai_width = that.samurai_anim.getBounds().width;
	that.samurai_height = that.samurai_anim.getBounds().height;
	that.ui.addChild(that.samurai);
	that.ui.addChild(that.samurai_anim);
}
// src/lib/logo/bonus_background.jpg
// src/helpers/gameHandlers/handleBonusRound.js
export default function handleBonusRound(msg, that) {
	if (GameConfigs.uiComponent[COMPONENTS.BONUS_GAME_DIALOGUE]) {
		GameConfigs.uiComponent.removeView(
			GameConfigs.uiComponent[COMPONENTS.BONUS_GAME_DIALOGUE]
		);
	}
	if (
		msg === 'started' &&
		GameConfigs.uiComponent[COMPONENTS.BONUS_GAME] === undefined
	) {
		document.body.style.backgroundImage = `url(${bonusbgimg})`;

		if (GameConfigs.doubleChance) {
			HELPERS.dispatchCustomEvent(EVENTS.DOUBLE_CHANCE, {
				doubleChance: false
			});
			GameConfigs.doubleChance = false;
		}
		// GameConfigs.bonusBuy = false;
		window.sm.stop('bg_music_lvl2', 1500);
		window.sm.stop('bg_music_lvl1', 1500);
		that.bgMusic_idle = false;
		that.bgMusic_in_game = false;
		if (!that.bgMusic_bonus) {
			window.sm.play({
				name: 'bg_music_lvl3',
				loop: true,
				background: true,
				fade: 300
			});
			that.bgMusic_bonus = true;
		}
		if (GameConfigs.settings.game_animation) {
			that.samurai.visible = true;
			that.samurai_anim.visible = true;
			that.samurai_anim.gotoAndPlay(0);
			that.samurai_anim.onComplete = () => {
				that.samurai_anim.gotoAndStop(0);
				that.viewTransitions.addBonusRoundViews();
				that.samurai.visible = false;
				that.samurai_anim.visible = false;
			};
		} else {
			that.viewTransitions.addBonusRoundViews();
		}
	}
	if (msg === 'finished') {
		window.sm.stop('bg_music_lvl3', 500);
		that.bgMusic_bonus = false;
		GameConfigs.modal = 'bonus_game_finish';
		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: 'bonus_game_finish' });
		GameConfigs.uiComponent.addView(BonusGameFinishedView);
	}
	if (msg === '') {
		GameConfigs.bonusBuy = false;

		that.viewTransitions.addIdleGameViews();
		that.viewTransitions.removeBonusView();
		window.sm.stop('bg_music_lvl3', 500);
		window.sm.play({
			name: 'bg_music_lvl1',
			loop: true,
			background: true,
			fade: 500
		});
		that.bgMusic_idle = true;
		that.bgMusic_in_game = false;
		that.bgMusic_bonus = false;
		GameConfigs.uiComponent.gridController = new MainGridController(
			GameConfigs.uiComponent,
			MainViewGrid
		);
		GameConfigs.uiComponent.resize(window.CurrentSize.w, window.CurrentSize.h);
		GameConfigs.reelComponent.resetBonus();
		if (GameConfigs.bonusRestore) {
			GameConfigs.bonusRestore = null;
		}
		if (GameConfigs.bonusRoundData) {
			GameConfigs.bonusRoundData = null;
		}
		if (GameConfigs.bonusRoundInfo) {
			GameConfigs.bonusRoundInfo = null;
		}
		if (GameConfigs.isFreeSpin) {
			HELPERS.dispatchCustomEvent(EVENTS.FREESPIN, {
				freespin: { ...GameConfigs.freeSpinLocal, hasBonus: false }
			});
			GameConfigs.freeSpinLocal = {
				...GameConfigs.freeSpinLocal,
				hasBonus: false
			};
			if (
				GameConfigs.freeSpinLocal.status === 'active' &&
				GameConfigs.freeSpinLocal.count > 0
			) {
				GameConfigs.uiComponent.addView(FreespinStatusbarView);
				let disabled = {
					bonus_widget: true,
					double_widget: true,
					info: false,
					settings: false,
					spin: false,
					auto: false,
					fast: false,
					quest_widget: true,
					bet_amount: true
				};
				GameConfigs.disabled = disabled;
				HELPERS.dispatchCustomEvent(EVENTS.IS_DISABLED, { disable: disabled });
				if (GameConfigs.autospin.pause) {
					GameConfigs.autospin.isAutoOn = true;
				}
			} else {
				GameConfigs.uiComponent.addView(FreespinWinView);
				HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: 'freespin_win' });
				HELPERS.disableAllButtons(true);
			}
		} else {
			if (GameConfigs.autospin.pause) {
				GameConfigs.autospin.isAutoOn = true;
			}
			HELPERS.disableAllButtons(false);
		}
	}
}
